// src/json/overlayData.json
export const overlaySectionCommercialsnowRemoval = {
    imageUrl: "/assets/imgs/services/6CommercialsnowRemoval/overlaySection/fondo.jpg",
    text: "The best Building Envelope Renewal /",
    highlight: "High-Rise Painting & Restoration services."
};
